/* eslint-disable max-len */
export const title = 'Ups, tenemos un problema';
export const subTitle = 'Ha ocurrido un error al ingresar, porfavor intentalo nuevamente. Si el problema persiste, comunicate con nosotros.';
export const retryButton = 'Reintentar';
export const helpButton = 'Pedir ayuda';
